export default "__VITE_ASSET__cd18dced__"